// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,

  apiUrl: 'https://parametros.free.beeceptor.com/api/v1',

  clientId: '6dfed1c9-50b8-49e6-8bd6-09d850f5ccba',

  baseUrl: {
    // auth: "https://login-appservice-back2.azurewebsites.net/",
    // auth: "https://localhost:7128/api/v1/",
    // logic: "https://localhost:7128/api/v1/",
    auth: 'https://wa-aeu-sds-dev-wapi-back.azurewebsites.net/api/v1/',
    logic: 'https://wa-aeu-sds-dev-wapi-back.azurewebsites.net/api/v1/',
    generic: 'https://wa-aeu-sds-dev-wapi-canonical.azurewebsites.net/api/v1'
  },

  PROCEDURE_SHARED_URI: 'https://apm-aeu-sds-dev-shared.azure-api.net/tramites-shared/api',
  PROCEDURE_SECURITY_URI: 'https://apm-aeu-sds-dev-shared.azure-api.net/security/api/v2/Security'
};
